@use "Styles/components/buttons";
@use "Static/icons/icomoon/style.scss";


:host {
    display: flex;
    justify-content: center;

    @keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    .vm-loading-spinner {
        display: inline-block;
        text-align: center;

        i {
            display: block;
            animation: spin .75s infinite steps(8);
        }
    }
}
